import { z } from 'zod';

import { AuthorizedContactId, LosId } from '../../BrandedIds';
import { AuthorizedContactName, AuthorizedContactType } from '../../loan/AuthorizedContact';
import { OptionalPhoneNumber } from '../../Phone';
import { zodTemporalPlainDate } from '../../Temporal';
import { OptionalEmailString } from '../../validations';

export const ExportableAuthorizedContact = z
  .object({
    id: AuthorizedContactId,
    loanId: LosId,
    type: AuthorizedContactType,

    email: OptionalEmailString,
    emailConsent: z.boolean(),
    homePhone: OptionalPhoneNumber,
    workPhone: OptionalPhoneNumber,
    cellPhone: OptionalPhoneNumber,
    otherPhone: OptionalPhoneNumber,

    name: AuthorizedContactName,
    companyName: z.string().optional(),
    /**
     * Don't expose this for now.
     */
    // ssn: OptionalSocialSecurityNumber,
    dateOfBirth: zodTemporalPlainDate.optional(),
  })
  .meta({ title: 'ExternalAuthorizedContact' });
